var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"5cab4729aa6b2d5802ed0f7c44ddba8386b4e2ff"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://b3f6dd1e93425d7abefe028573e713c4@o354119.ingest.us.sentry.io/4507603322470400",

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
  enabled: process.env.NODE_ENV === "production",

  // Sampling only half of errors should increase the likelihood that we able to get a
  // replay for most errors
  replaysOnErrorSampleRate: 0.5,

  // Replays without errors are largely useless for what we're doing, since there's no
  // real analytics or aggregate metrics to get from them.
  replaysSessionSampleRate: 0,

  // A lot of these very noisy errors come from third party scripts (likely analytics)
  // https://github.com/getsentry/sentry-javascript/issues/2546#issuecomment-703331367
  // https://github.com/getsentry/sentry-javascript/issues/2546#issuecomment-863948520
  // The information in the sentry error is also extremely sparse as it's just getting
  // the promise rejection and not any other info, such as a stack trace or caller and
  // the replays are all user-facing error free as well.
  ignoreErrors: [
    "Non-Error exception captured",
    "Non-Error promise rejection captured",
  ],

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
});
